import { useWorkspaceStore } from "@/store";
import { useQuery } from "@/hooks";
import { Loader } from "@/pages/_loading";
import { useUser } from "@clerk/clerk-react";

export function WorkspacesWrapper(props: React.PropsWithChildren) {
   const { fetchWorkspaces } = useWorkspaceStore((state) => state);
   const { isSignedIn } = useUser();
   const { isLoading, isFetching } = useQuery({
      queryKey: ["FETCH_WORKSPACES"],
      queryFn: () => {
         return fetchWorkspaces();
      },
      enabled: !!isSignedIn,
   });
   if ((isLoading || isFetching) && isSignedIn) {
      return <Loader />;
   }

   return <>{props.children}</>;
}
